// extracted by css-extract-rspack-plugin
export default {"cls1":"Popover-cls1_Z2H","cls2":"Popover-cls2_4dd Popover-cls1_Z2H","strategy-fixed":"Popover-strategy-fixed_qRY"};